import { nextTick, onMounted, onBeforeUnmount, Ref } from "vue";

export default function useSwipes(targetContainer: Ref<HTMLElement | null>, swipeLeftCallback: Function, swipeRightCallback: Function, isToggleListenersAutomatically = true) {
  function addTouchListeners(_targetContainer?: HTMLElement): void {
    (_targetContainer || targetContainer.value)?.addEventListener("touchstart", handleTouchStart);
    (_targetContainer || targetContainer.value)?.addEventListener("touchend", handleTouchEnd);
    (_targetContainer || targetContainer.value)?.addEventListener("touchmove", handleTouchMove);

    (_targetContainer || targetContainer.value)?.addEventListener("mousedown", handleMouseDown);
    (_targetContainer || targetContainer.value)?.addEventListener("mouseup", handleTouchEnd);
    (_targetContainer || targetContainer.value)?.addEventListener("mousemove", handleMouseMove);
  }
  function removeTouchListeners(_targetContainer?: HTMLElement): void {
    (_targetContainer || targetContainer.value)?.removeEventListener("touchstart", handleTouchStart);
    (_targetContainer || targetContainer.value)?.removeEventListener("touchend", handleTouchEnd);
    (_targetContainer || targetContainer.value)?.removeEventListener("touchmove", handleTouchMove);

    (_targetContainer || targetContainer.value)?.removeEventListener("mousedown", handleMouseDown);
    (_targetContainer || targetContainer.value)?.removeEventListener("mouseup", handleTouchEnd);
    (_targetContainer || targetContainer.value)?.removeEventListener("mousemove", handleMouseMove);
  }

  onMounted(async (): Promise<void> => {
    if (isToggleListenersAutomatically) {
      await nextTick(addTouchListeners);
    }
  });

  onBeforeUnmount((): void => {
    if (isToggleListenersAutomatically) {
      removeTouchListeners();
    }
  });

  let isTouchMoveInProgress: boolean = false;

  let touchHorizontalDistance: number = 0;
  let touchHorizontalStartPoint = null;

  let touchVerticalDistance: number = 0;
  let touchVerticalStartPoint = null;

  function handleTouchStart(event: TouchEvent): void {
    isTouchMoveInProgress = true;
    resetStartPoint(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
  }

  function handleMouseDown(event: MouseEvent): void {
    isTouchMoveInProgress = true;
    resetStartPoint(event.pageX, event.pageY);
  }

  function resetStartPoint(x: number, y: number): void {
    touchHorizontalStartPoint = Math.round(x);
    touchVerticalStartPoint = Math.round(y);
  }

  function handleTouchEnd(): void {
    isTouchMoveInProgress = false;

    touchHorizontalStartPoint = null;
    touchHorizontalDistance = 0;

    touchVerticalStartPoint = null;
    touchVerticalDistance = 0;
  }

  function handleCursorMove(x: number, y: number): void {
    if (!isTouchMoveInProgress) {
      return;
    }
    touchHorizontalDistance = -(Math.round(touchHorizontalStartPoint) - Math.round(x));
    touchVerticalDistance = -(Math.round(touchVerticalStartPoint) - Math.round(y));

    const stepSize: number = 100;

    if (touchHorizontalDistance >= stepSize) {
      swipeLeftCallback();
      resetStartPoint(x, y);
      isTouchMoveInProgress = false;
      //
    } else if (touchHorizontalDistance <= -stepSize) {
      swipeRightCallback();
      resetStartPoint(x, y);
      isTouchMoveInProgress = false;
    }
  }

  function handleTouchMove(event: TouchEvent): void {
    handleCursorMove(event.changedTouches[0].pageX, event.changedTouches[0].pageY);
  }

  function handleMouseMove(event: MouseEvent): void {
    handleCursorMove(event.pageX, event.pageY);
  }

  return {
    addTouchListeners,
    removeTouchListeners,
  };
}
